<template>
    <v-chip
        :small="size === 'small'"
        :color="tagColor"
        :text-color="tagTextColor"
        :close="closable"
        @mousedown.native="onChipMouseDown"
        @click:close="$emit('close', tag)"
        :class="chipClass"
        class="font-weight-bold tag-chip"
    >
        {{ tagName }}
    </v-chip>
</template>

<script>
export default {
    name: "Tag",
    props: {
        tag: {
            type: [Object, String],
            required: true,
        },
        size: {
            type: String,
            default: "small",
            validator: (value) => ["small", "default", "large"].includes(value),
        },
        closable: {
            type: Boolean,
            default: false,
        },
        chipClass: {
            type: String,
            default: "",
        },
    },
    computed: {
        tagName() {
            if (typeof this.tag === "object" && this.tag.name) {
                return this.tag.name;
            }
            if (typeof this.tag === "object" && this.tag.text) {
                return this.tag.text;
            }
            if (typeof this.tag === "object" && this.tag.value) {
                return this.tag.value;
            }
            return this.tag;
        },
        tagTextColor() {
            let hex = this.tagColor.replace(/^#/, "");
            if (/^[0-9a-f]{3}$/i.test(hex)) {
                hex = hex.split("").map((value) => value + value).join("");
            }
            if (!/^[0-9a-f]{6}$/i.test(hex)) return "white";
            const channels = [0, 2, 4].map((offset) => {
                const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;
                return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
            });
            const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
            return luminance > 0.179 ? "black" : "white";
        },
        tagColor() {
            if (typeof this.tag === "object" && this.tag.color) {
                return this.tag.color;
            }
            return "#9E9E9E";
        },
    },
    methods: {
        onChipMouseDown(event) {
            if (!this.closable || !event || !event.target) {
                return;
            }
            const target = event.target;
            const isClose =
                (target.classList && target.classList.contains("v-chip__close")) ||
                (target.closest && target.closest(".v-chip__close"));
            if (isClose) {
                // Prevent v-combobox/v-select from stealing the click before close fires.
                event.stopPropagation();
                event.preventDefault();
            }
        },
    },
};
</script>


<style scoped>
.tag-chip ::v-deep .v-chip__close { color: inherit !important; opacity: 1; }
</style>
